import Request from 'utils/request';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import moment from 'moment';

const memCache = new Map(); // activityId -> effectiveTime
const inflight = new Map(); // activityId -> Promise

function getCacheKey(activityId) {
  return `activity_effectiveTime_${activityId}`;
}

function formatToMinute(effectiveTime) {
  if (!effectiveTime) return '';
  const raw = String(effectiveTime).trim();
  if (!raw) return '';

  // Try strict parse first for the common formats we expect from backend.
  const strict = moment(raw, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', moment.ISO_8601], true);
  if (strict.isValid()) return strict.format('YYYY-MM-DD HH:mm');

  // Fallback: non-strict parse (covers "YYYY/MM/DD HH:mm:ss" etc).
  const loose = moment(raw);
  return loose.isValid() ? loose.format('YYYY-MM-DD HH:mm') : raw;
}

async function fetchEffectiveTime(activityId) {
  if (!activityId) return '';
  const id = String(activityId);

  if (memCache.has(id)) return memCache.get(id) || '';
  try {
    const cached = sessionStorage.getItem(getCacheKey(id));
    if (cached) {
      memCache.set(id, cached);
      return cached;
    }
  } catch (e) {
    // ignore sessionStorage read failure
  }

  if (inflight.has(id)) return inflight.get(id);

  const p = Request({
    url: `promotion/activity/id/${id}`,
    host: Config.HOST_MALL,
    method: 'get',
    ignoreErr: true
  })
    .then((res) => {
      const data = (res && res.data) || {};
      const effectiveTime = formatToMinute(data.baseReqDto.effectiveTime || '');
      if (effectiveTime) {
        memCache.set(id, effectiveTime);
        try {
          sessionStorage.setItem(getCacheKey(id), effectiveTime);
        } catch (e) {
          // ignore sessionStorage write failure
        }
      }
      return effectiveTime;
    })
    .catch(() => '')
    .finally(() => {
      inflight.delete(id);
    });

  inflight.set(id, p);
  return p;
}

function rememberEffectiveTime(activityId, effectiveTime) {
  if (!activityId || !effectiveTime) return;
  const id = String(activityId);
  memCache.set(id, effectiveTime);
  try {
    sessionStorage.setItem(getCacheKey(id), effectiveTime);
  } catch (e) {
    // ignore sessionStorage write failure
  }
}

/**
 * 活动未开始时的统一 Toast。
 * @param {string|number} activityId
 * @param {{ effectiveTime?: string, activityData?: { effectiveTime?: string } }} [options]
 *   - 已调用 `promotion/activity/id` 时传入 `activityData`：只使用该对象上的 `effectiveTime`，不会再请求接口（无字段则走兜底文案）。
 *   - 或显式传入 `effectiveTime`。
 */
export async function toastActivityNotStarted(activityId, options) {
  const opts = options && typeof options === 'object' ? options : {};
  let effectiveTime;
  if (opts.effectiveTime !== undefined) {
    effectiveTime = opts.effectiveTime;
  } else if (Object.prototype.hasOwnProperty.call(opts, 'activityData')) {
    effectiveTime =
      opts.activityData &&
      opts.activityData.baseReqDto &&
      opts.activityData.baseReqDto.effectiveTime
        ? opts.activityData.baseReqDto.effectiveTime
        : '';
  } else {
    effectiveTime = await fetchEffectiveTime(activityId);
  }

  if (effectiveTime) {
    const formatted = formatToMinute(effectiveTime);
    rememberEffectiveTime(activityId, formatted);
    Toast.info(`活动将于${formatted} 暖心开启，\n敬请期待～`);
  } else {
    Toast.info('活动将于稍后暖心开启，\n敬请期待～');
  }
}



// WEBPACK FOOTER //
// ./src/utils/activityTips.js